import type { JobDetails } from '@xing-com/crate-jobs-helpers';

import { JobsXingletWrapper } from '../../../jobs-xinglet';

export const JobMetadata = JobsXingletWrapper<{ job: JobDetails }>(
  '@xing-com/crate-jobs-domain-job-details-job-metadata'
);
